export const intersectionObserver = (function ($) {

    // === INSTRUCTIONS === //
    // every item that should be animated must have:
    // - class="animate"
    // - data-animation="...": with the corresponding class with animation (see animations.scss)
    // - data-animation-delay="animation-delay-xx" (optional): where xx is a number from 1 to 20 (see animations.scss)

    function init() {
        // first check if IntersectionObserver is compatible with the current browser
        if (('IntersectionObserver' in window)) {
            const observer = new IntersectionObserver(entries => {
                // Loop over the entries
                entries.forEach(entry => {
                    // If the element is visible
                    if (entry.isIntersecting) {
                        // Get data attribute to define the animation and delay
                        let animation = entry.target.getAttribute('data-animation');
                        let dataDelay = entry.target.getAttribute('data-animation-delay');
                        // add delay class only if set
                        let delay = (dataDelay !== null) ? dataDelay : 'animation-delay-default';
                        // Add the animation class
                        entry.target.classList.add(animation, delay);
                    }
                });
            });
            // define the observer class
            let target = '.animate';
            // forEach needed for multiple elements on screen
            document.querySelectorAll(target).forEach((i) => {
                if (i) {
                    observer.observe(i);
                }
            });
        } else {
            // define the class
            let target = '.animate';
            // forEach needed for multiple elements on screen
            document.querySelectorAll(target).forEach((i) => {
                if (i) {
                    i.target.classList.add('animate-force-visibility')
                }
            });
        }
    }

    return {
        init: init
    }

})(jQuery);